import { render, staticRenderFns } from "./RelatorioJogador.vue?vue&type=template&id=031336da&scoped=true"
import script from "./RelatorioJogador.vue?vue&type=script&lang=js"
export * from "./RelatorioJogador.vue?vue&type=script&lang=js"
import style0 from "./RelatorioJogador.vue?vue&type=style&index=0&id=031336da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031336da",
  null
  
)

export default component.exports